import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import withFieldError from 'components/form/with-error'

export const UrlInput = ({ input, placeholder, meta: { touched, error } }) => (
  <div>
    <input
      className={
        'form-control right-element-no-borders ' +
        (error && touched ? 'has-error' : '')
      }
      placeholder={placeholder}
      {...input}
      type='url'
    />
  </div>
)

UrlInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

export const UrlInputWithError = withFieldError(UrlInput)

const MessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

MessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const MessageInputWithError = withFieldError(MessageInput)

const FacebookCommentFields = ({ name }) => {
  // https://developers.facebook.com/docs/graph-api/reference/v13.0/object/comments
  return (
    <div className='row'>
      <div className='col-sm-12'>
        <Field
          component={MessageInputWithError}
          label='Message'
          name={`${name}.message`}
          // eslint-disable-next-line no-template-curly-in-string
          placeholder='Message - ${senderId},${senderName},${reactionType},${eventText},${fbUserTag}'
        />
      </div>
      <div className='col-sm-12'>
        <Field
          component={UrlInputWithError}
          label='Image Attachment URL'
          name={`${name}.attachmentUrl`} // Photo
          placeholder='Image attachment URL'
        />
      </div>
      <div className='col-sm-12'>
        <Field
          component={UrlInputWithError}
          label='GIF Attachment URL'
          name={`${name}.attachmentShareUrl`} // GIF
          placeholder='GIF Attachment URL'
        />
      </div>
    </div>
  )
}

FacebookCommentFields.propTypes = {
  name: PropTypes.string
}

export default FacebookCommentFields



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/facebook/facebook-comment/index.js